// Solaris: smart search — redirect specific terms to curated collections.
// NO phrase-quoting (causes false negatives: e.g. "tinctura nuc" wouldn't match "Tinctura de Nuca").
(function(){
  function normalize(s) {
    if (!s) return '';
    return s.toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // Exact phrase -> collection handle. Only triggers on exact match (normalized).
  var REDIRECTS = {
    'ulei esential': 'uleiuri-esentiale',
    'uleiuri esentiale': 'uleiuri-esentiale',
    'ulei esentiale': 'uleiuri-esentiale',
    'uleiuri esentiale aromaterapie': 'uleiuri-aromaterapie',
    'uleiuri aromaterapie': 'uleiuri-aromaterapie'
  };

  function maybeRedirect(q) {
    var n = normalize(q);
    if (REDIRECTS[n]) return '/collections/' + REDIRECTS[n];
    return null;
  }

  function attachToForm(form) {
    if (form.dataset.solarisStrictSearchAttached) return;
    form.dataset.solarisStrictSearchAttached = '1';
    form.addEventListener('submit', function(e){
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      var target = maybeRedirect(input.value);
      if (target) {
        e.preventDefault();
        window.location.href = target;
      }
    }, true);
  }

  function init() {
    document.querySelectorAll('form[action*="/search"]').forEach(attachToForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var obs = new MutationObserver(function(){
    document.querySelectorAll('form[action*="/search"]:not([data-solaris-strict-search-attached])').forEach(attachToForm);
  });
  if (document.body) {
    obs.observe(document.body, { childList: true, subtree: true });
  } else {
    window.addEventListener('DOMContentLoaded', function(){
      obs.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
